export const Countries = ["GB", "DK", "FI", "NO", "SE"] as const;
export type Country = (typeof Countries)[number];
